module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tm-body"
  }, [_c('ol', {
    staticClass: "tm-items"
  }, [_vm._t("default")], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2924e736"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/timeline.vue
// module id = 1391
// module chunks = 1